var map = {
	"./4g-5g-services.jpeg": [
		8061,
		61
	],
	"./4g-routers.jpeg": [
		7799,
		799
	],
	"./5g-routers.jpeg": [
		5019,
		19
	],
	"./banner-1.jpeg": [
		3684,
		684
	],
	"./banner-2.jpeg": [
		834,
		834
	],
	"./banner-3.jpeg": [
		4270,
		270
	],
	"./iot-caas.jpeg": [
		7739,
		739
	],
	"./newsletter-signup.jpeg": [
		9297,
		720
	],
	"./products.jpeg": [
		14,
		14
	],
	"./sdwan.jpeg": [
		8085,
		85
	],
	"./sectors.jpeg": [
		7822,
		822
	],
	"./social-media.jpeg": [
		4385,
		385
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9851;
module.exports = webpackAsyncContext;